import { Navigate } from 'react-router';

import { LANDING } from '#src/constants/__generated__/routes.ts';
import { useTruncatedLocation } from '#src/hooks/useTruncatedLocation.ts';

const useRedirectToLandingWithAction = (
  action: 'signup' | 'signin',
  to?: string
) => {
  const location = useTruncatedLocation();

  return function RedirectToLanding() {
    return (
      <Navigate
        replace
        to={{
          pathname: to || LANDING,
          search: `action=${action}${action === 'signin' ? `&redirectUrl=${encodeURIComponent(location)}` : ''}`,
        }}
      />
    );
  };
};

export const useRedirectToSignup = (to?: string) =>
  useRedirectToLandingWithAction('signup', to);
export const useRedirectToSignin = (to?: string) =>
  useRedirectToLandingWithAction('signin', to);
